import { render, staticRenderFns } from "./hotels-list-fs.vue?vue&type=template&id=5a4e39dd"
import script from "./hotels-list-fs.vue?vue&type=script&lang=js"
export * from "./hotels-list-fs.vue?vue&type=script&lang=js"
import style0 from "./hotels-list-fs.vue?vue&type=style&index=0&id=5a4e39dd&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports